import React from 'react';
import PropTypes from 'prop-types';

import ButtonGroupComponent from '../../../../components/common/forms/ButtonGroupComponent/ButtonGroupComponent';
import {
  WAREHOUSE_LOCATION_CHAMBERS,
  WAREHOUSE_LOCATION_COLUMNS,
  WAREHOUSE_LOCATION_LETTERS,
  WAREHOUSE_LOCATION_LEVELS,
} from '../../../../utils/constants';
import styled from 'styled-components';
import { constantsToAutocomplete } from '../../../../utils/misc';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';

interface LocationEditProps {
  setField: (fieldName: string, value: string) => void;
  chamberNumber: string;
  column: string;
  letter: string;
  level: string;
  touched?: Record<string, boolean>;
  errors?: Record<string, string>;
}

export default function LocationEdit({
  setField,
  chamberNumber,
  column,
  letter,
  level,
  touched = {},
  errors = {},
}: LocationEditProps): JSX.Element {
  return (
    <div
      style={{
        paddingBottom: 50,
      }}
    >
      <WrapperButtons>
        <ButtonGroupComponent
          options={constantsToAutocomplete(WAREHOUSE_LOCATION_CHAMBERS)}
          name="chamberNumber"
          onChange={(v): void => {
            setField('chamberNumber', v);
          }}
          cols={16}
          touched={touched}
          errors={errors}
          initialValue={chamberNumber}
          buttonsPerRow={10}
        />
        <ButtonGroupComponent
          options={constantsToAutocomplete(WAREHOUSE_LOCATION_COLUMNS)}
          name="column"
          onChange={(v): void => {
            setField('column', v);
          }}
          cols={24}
          touched={touched}
          errors={errors}
          initialValue={column}
          buttonsPerRow={10}
        />
        <ButtonGroupComponent
          options={constantsToAutocomplete(WAREHOUSE_LOCATION_LETTERS)}
          name="letter"
          onChange={(v): void => {
            setField('letter', v);
          }}
          cols={12}
          touched={touched}
          errors={errors}
          initialValue={letter}
          buttonsPerRow={10}
        />
        <ButtonGroupComponent
          options={constantsToAutocomplete(WAREHOUSE_LOCATION_LEVELS)}
          name="level"
          onChange={(v): void => {
            setField('level', v);
          }}
          cols={12}
          touched={touched}
          errors={errors}
          initialValue={level}
          buttonsPerRow={10}
        />
      </WrapperButtons>
    </div>
  );
}

const WrapperButtons = styled.div`
  background: #f4f4f4;
  border-radius: 20px;
  padding: 35px;
  max-width: 760px;
  width: 100%;
`;
